import { useCallback } from 'react'

import useKeyboardShortcuts from '@/hooks/useKeyboardShortcuts'
import { useNavigation } from '@/hooks/useNavigation'
import { UserMenu } from '@/components/UserMenu'
import { Button } from '@/components/Button'
import { Search } from '@/components/Search'
import { HomeIcon } from '@/icons'

import s from './Header.module.css'

type Props = {
  showCreateButton?: boolean
  showBackButton?: boolean
}

export const Header = ({
  showCreateButton = true,
  showBackButton = false,
}: Props) => {
  const { navigate } = useNavigation()

  const handleHomeClick = useCallback(() => {
    navigate('/')
  }, [navigate])

  const handleCreateClick = useCallback(() => {
    navigate('/create')
  }, [navigate])

  useKeyboardShortcuts({
    c: handleCreateClick,
  })

  return (
    <div className={s.header}>
      {showBackButton ? (
        <Button
          variant="secondary"
          iconLeft={HomeIcon}
          onClick={handleHomeClick}
        >
          {''}
        </Button>
      ) : (
        <Search />
      )}

      <div className={s.actions}>
        {showCreateButton && (
          <Button variant="primary" iconRight={'C'} onClick={handleCreateClick}>
            Create Link
          </Button>
        )}
        <UserMenu />
      </div>
    </div>
  )
}
